import { render } from "./FolderName.vue?vue&type=template&id=b02f543c"
import script from "./FolderName.vue?vue&type=script&lang=js"
export * from "./FolderName.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__